import { navigateTo } from "@/services/NavigationService";

// Environment detection and redirect utilities
export const detectEnvironment = () => {
  const hostname = window.location.hostname;
  const origin = window.location.origin;
  
  // Production environment
  if (hostname === 'lamulamu.com' || hostname === 'www.lamulamu.com') {
    return {
      type: 'production' as const,
      baseUrl: 'https://lamulamu.com',
      verifyUrl: 'https://lamulamu.com/verify'
    };
  }
  
  // Staging environment - includes the new staging URL pattern
  if (hostname.includes('staging') || hostname.includes('test') || hostname.includes('lamulamu-12.lovable.app')) {
    return {
      type: 'staging' as const,
      baseUrl: origin,
      verifyUrl: `${origin}/verify`
    };
  }
  
  // Preview/development environment
  return {
    type: 'preview' as const,
    baseUrl: origin,
    verifyUrl: `${origin}/verify`
  };
};

// Get the appropriate redirect URL for email verification
export const getEmailRedirectUrl = (type: 'signup' | 'recovery' | 'invite' = 'signup') => {
  // Always redirect to production for email verification links
  // This ensures all users land on the stable production site
  return `https://lamulamu.com/verify?type=${type}`;
};

// Get post-verification redirect URL based on environment and user context
export const getPostVerificationRedirect = (
  userContext?: {
    isVendor?: boolean;
    isAdmin?: boolean;
    hasCompletedProfile?: boolean;
  }
) => {
  const env = detectEnvironment();
  
  // Determine where to send the user after successful verification
  if (userContext?.isAdmin) {
    return `${env.baseUrl}/admin`;
  }
  
  if (userContext?.isVendor) {
    return `${env.baseUrl}/vendor`;
  }
  
  if (userContext?.hasCompletedProfile === false) {
    return `${env.baseUrl}/setup-profile`;
  }
  
  // Default to home page
  return env.baseUrl;
};

// Navigate with environment awareness
export const navigateWithEnvironmentContext = (
  navigate: (path: string, options?: any) => void,
  path: string,
  options?: any
) => {
  const env = detectEnvironment();
  
  // If we're navigating to a different environment, use full URL
  if (path.startsWith('http') && !path.startsWith(env.baseUrl)) {
    window.location.href = path;
    return;
  }
  
  // Use the navigation service for local navigation
  navigateTo(navigate, path, options);
};

// Log environment information for debugging
export const logEnvironmentInfo = () => {
  const env = detectEnvironment();
  console.log(`[Environment] Detected: ${env.type}`, {
    baseUrl: env.baseUrl,
    verifyUrl: env.verifyUrl,
    hostname: window.location.hostname,
    origin: window.location.origin
  });
  return env;
};